export default "__VITE_ASSET__CYy5a$DQ__"